<template>
  <div class="content-wrap">
    <div class="register-wrap">
      <div class="row">
        <div class="col-md-3">
          <div class="mb-3">
            <ElLabel name="이벤트명">
              <template #end="{id}">
                <ElInput :id="id" v-model="state.leadParams.event_nm"  @inputClick="openEventModal" :readonly="true" onlyNumber/>
              </template>
            </ElLabel>
              <!-- 이벤트매핑 호출 -->
              <eventRegModal ref="srchEventModal" call-page="sm" @return="(r) => getEventInfo(r)"/>                
          </div>
        </div>
        <div class="col-md-3">
          <div class="mb-3">
            <ElLabel name="영업대표">
              <template #end="{id}">
                <ElInput :id="id" ref="salesBossRef" v-model="state.leadParams.sales_boss" @update:modelValue="r=>getNameMask('salesBossRef',r)" :maxlength="10"/>
              </template>
            </ElLabel>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-3">
          <div class="mb-3">
            <ElLabel name="회사" :required="true">
              <template #end="{id}">
                <div class="input-group mb-3" @click="openModal('companyReg')">
                  <ElInput :id="id" ref="cmpNmRef" v-model="state.leadParams.cmp_nm" readonly/>
                  <ElButton type="s-search"></ElButton>
                </div>
              </template>
            </ElLabel>

            <CompanyModal ref="companyModalRef" @return="(r) => getInfo(r,'cmp')" />


          </div>
        </div>
        <div class="col-md-3">
          <div class="mb-3">
            <ElLabel name="사업부명">
              <template #end="{id}">
                <ElInput :id="id" ref="deptRef" v-model="state.leadParams.cmp_dvsn_nm" @update:modelValue="r=>getNameMask('deptRef',r)"/>
              </template>
            </ElLabel>
          </div>
        </div>
        <div class="col-md-3">
          <div class="mb-3">
            <ElLabel name="이름" :required="true">
              <template #end="{id}">
                <ElInput :id="id" ref="nameRef" v-model="state.leadParams.usr_nm" @update:modelValue="r=>getNameMask('nameRef',r)" :maxlength="255"/>
              </template>
            </ElLabel>
        </div>
        </div>
        <div class="col-md-3">
          <div class="mb-3">
            <ElLabel name="직책">
              <template #end="{id}">
                <ElInput :id="id" ref="postionRef" v-model="state.leadParams.postion" @update:modelValue="r=>getNameMask('postionRef',r)" :maxlength="10"/>
              </template>
            </ElLabel>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-3">
          <div class="mb-3">
            <ElLabel name="휴대폰번호" :required="true">
              <template #end="{id}">
                <ElInput 
                :id="id" 
                ref="mobileRef" 
                v-model="state.leadParams.mobile" 
                @update:modelValue="getMobileMask"
                />
              </template>
            </ElLabel>
          </div>
        </div>
        <div class="col-md-3">
          <div class="mb-3">
            <ElLabel name="이메일">
              <template #end="{id}">
                <ElInput :id="id" ref="emailRef" v-model="state.leadParams.email" :maxlength="255"/>
              </template>
            </ElLabel>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-3">
          <div class="mb-3">
            <label for="" class="form-label">관심분야</label>
            <SelectCode cd_gr="ATN_CD" :matchCd="state.leadParams.attn_cd"
              @return="(r) => (state.leadParams.attn_cd = r.cd_id)" />
          </div>
        </div>
        <div class="col-md-3">
          <div class="mb-3">
            <ElLabel name="산업분야">
              <template #end>
                <!-- <SelectCode cd_gr="TRD_CD" :matchCd="state.leadParams.inst_cd"
                @return="(r) => (state.leadParams.inst_cd = r.cd_id)" /> -->
                <TreeSelect :data-list="state.cmpCls" v-model="state.inst_cd" @return="updateProdSelect"/>
              </template>
            </ElLabel>
          </div>
        </div>
        <div class="col-md-3">
          <div class="mb-3">
            <ElLabel name="성향" :required="true">
              <template #end="{id}">
                <SelectCode cd_gr="TRD_CD"  ref="trendRef" :matchCd="state.leadParams.trend_cd"
              @return="(r) => (state.leadParams.trend_cd = r.cd_id)" />
              </template>
            </ElLabel>
            
          </div>
        </div>
        <div class="col-md-3">
          <div class="mb-3">
            <ElLabel name="즐겨찾기">
              <template #end="{id}">
                <ElButton
                  :id="id"
                  type="bookmarkL"
                  :active="state.leadParams.bkmark_yn == 'Y'"
                  @buttonClick="state.leadParams.bkmark_yn == 'Y' ? changeVal('bkmark_yn', 'N') : changeVal('bkmark_yn', 'Y')"
                >
                  즐겨찾기 추가
                </ElButton>
              </template>
            </ElLabel>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12">
          <div class="mb-3">
            <ElLabel name="메모">
              <template #end="{id}">
                <ElTextarea class="form-control" v-model="state.leadParams.note" :id="id" :rows="3" :maxlength="512"/>
              </template>
            </ElLabel>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-3">
          <div class="mb-3">
            <ElLabel name="영업기회 Convert/Omit" :required="true">
              <template #end="{id}">
                <SelectCode ref="omtSelectRef" chk_ess="Y" cd_gr="OMT_CD" :match-cd="state.leadParams.oprtn_cd" @return="(r) => (state.leadParams.oprtn_cd = r.cd_id)"/>
              </template>
            </ElLabel>
            
          </div>
        </div>

        <div class="col-md-3"  v-if="state.leadParams.oprtn_cd === 'OMT02'" >
          <div class="mb-3">
            <ElLabel name="영업기회ID">
              <template #end="{id}">
                <ElInput ref="salesIdRef" :id="id" v-model="state.leadParams.sales_id" readonly @click="openModal('sale')"/>
              </template>
            </ElLabel>
          </div>
        </div>

        <div class="col-md-3" v-if="state.leadParams.oprtn_cd === 'OMT03'">
          <div class="mb-3">
            <ElLabel name="Omit사유">
              <template #end="{id}">
                <ElInput ref="omitRstRef" :id="id" v-model="state.leadParams.omit_rst"/>
              </template>
            </ElLabel>
          </div>
        </div>
      </div>


      <!--todo : captionList 공통컴포넌트 적용-->
      <div class="row">
        <Caption
          ref="captionRef"
          :tbId="'lead'"
          :cap_seq="state.leadParams.ld_seq"
        />
      </div>
    </div><!-- //register-wrap -->

    <div class="text-end py-3">
      <ElButton type="primary" @buttonClick="router.back()">이전</ElButton>
      <ElButton type="primary" @buttonClick="checkValidation('T')">임시저장</ElButton>
      <ElButton type="primary" @buttonClick="router.push('/mp/MMP_AM_001')">임시저장함</ElButton>
      <!-- 링크 : 마이페이지 임시저장함으로 간다.  -->
      <ElButton type="primary" @buttonClick="checkValidation('C')">등록</ElButton>
    </div>

    <div class="accordion" id="accordionPanelsStayOpenExample">
      <div class="accordion-item">
        <h2 class="accordion-header">
          <ElButton type="accordionHeader" target="panelsStayOpen-collapseOne">
            첨부파일
          </ElButton>
        </h2>
        <div id="panelsStayOpen-collapseOne" class="accordion-collapse collapse">
          <div class="accordion-body accordion-body-register">

            <FileUpload ref="fileUploadRef" @return="res => getFileList(res)"/>
          </div>
        </div>
      </div>
    </div>
  </div>
  <SalesModal ref="salesRegModalRef" @return="(r) => getInfo(r,'sale')" />
</template>

<script setup>
import { reactive, onBeforeMount, ref,watch} from 'vue';
import SalesModal from "@/components/common/modal/SalesModal.vue";
import eventRegModal from '@/components/common/modal/EventRegModal.vue';
import Caption from '@/components/common/CaptionList.vue';
import FileUpload from '@/components/common/FileUpload.vue';
import CompanyModal from "@/components/common/modal/CompanyModal.vue";
import SelectCode from "@/components/common/SelectCode.vue";
import TreeSelect from "@/components/common/TreeSelect.vue";
import routerCmn from '@/js/vueRouterCmn';
import { useRouter } from "vue-router";
import common from '@/js/common';
import { useCodeStore } from '@/store/code'
const codeStore = useCodeStore()

import { useLoading } from '@/composable/Loading.js'
const { setIsLoading } = useLoading()
import {leadList, leadEdit } from '@/api/lead';
import { classList } from '@/api/comp';

const router = useRouter();
const fileUploadRef = ref();
const companyModalRef = ref();
const mobileRef = ref(null);
const srchEventModal = ref()
const nameRef = ref();
const cmpNmRef = ref();
const salesBossRef = ref();
const postionRef = ref();
const captionRef = ref();
const deptRef = ref()
const trendRef = ref()
const emailRef = ref()
const salesRegModalRef = ref()
const omtSelectRef = ref()
const omitRstRef = ref()
const salesIdRef = ref()


onBeforeMount(async () => {
  await getCompCls()
})

const changeVal = (key, val) => {
  state.leadParams[key] = val;
};



const state = reactive({
  inst_cd : {},
  cmpCls : [],
  //즐겨찾기
  sFavorites: [
    { text: 'Y', value: 'YN001' },
    { text: 'N ', value: 'YN002' },
  ],
  Favorites: 'YN002',
  Propensities: 'TRD01',


  tmpFileList: [],
  fileParams: {
    up_path: '',
    fileListVo: []
  },

  //파일 첨부 데이터
  fileList: [],

  leadParams: {
    attch_seq: 0,
    ld_seq: '',
    sales_id: '',
    event_seq:null,
    event_nm: '',
    cmp_nm : '',
    usr_nm: '',
    email: '',
    mobile: '',
    cmp_info_seq: '',
    postion: '',
    sales_boss: '',
    note: '',
    enable_yn: 'Y',
    bkmark_yn: "N",
    trend_cd: '',
    indst_cd: '',
    del_yn: 'N',
    tmp_yn: 'N',
    cap_seq : 0,
    oprtn_cd : '',
    omit_rst : '',
    tb_id : 'lead',
    attachFileVO: {
      file_div_id: '10',
      file_seq: '', //추가 된 파일 seq 전송
      del_file_seq: '' // 삭제해야 할 파일 seq 전송
    },
    page_count: 1,
    unit_count: 100000,
  },
  delFileList: [],
})


watch(() => state.leadParams.oprtn_cd,(newValue) => {
  if(newValue === 'OMT02'){
    state.leadParams.omit_rst = ''
    openModal('sale')
  }else if(newValue === 'OMT03'){
    state.leadParams.sales_id = ''
  }else if(newValue === 'OMT01'){
    state.leadParams.sales_id = ''
    state.leadParams.omit_rst = ''
  }
})


//모바일 형식  (010-0000-0000)  
const getMobileMask = (mobile) => {
  mobileRef.value.input.value = common.phoneFormat(mobile)
  state.leadParams.mobile = common.phoneFormat(mobile)
}

//이메일 형식 
const getEmailMark = (email) => {

  if(!common.checkEmail(email)){
    alert("이메일 형식을 확인해주세요")
    return false
  }else{
    state.leadParams.email
  }
}

//특수문자
const getNameMask = (type,data = '') => {
    let uptData = common.checkSpecChar(data)
    switch(type){
      case 'nameRef' : 
      state.leadParams.usr_nm = uptData
        break
      case 'deptRef' : 
      state.leadParams.dept = uptData
        break
      case 'salesBossRef' : 
      state.leadParams.sales_boss = uptData
        break
      case 'postionRef' : 
      state.leadParams.postion = uptData
        break
    }

    return uptData
}


//모달open 함수
const openModal = async (modal) => {
  if (modal == "upload") {
    try {
      setIsLoading(true)
      let params = {
        page_count: 1,
        unit_count: 100000,
      };
      const res = await leadList(params)
      state.excelModalData = res.rtn;
    } catch (error) {
      console.log("api error", error);
      alert("매니저 조회 실패");
    } finally {
      // setIsLoading(false)
    }
  } else if ((modal === "companyReg")) {
    companyModalRef.value.openModal();
  }else if(modal === 'sale'){
    salesRegModalRef.value.openModal()
  }
};

//모달에서 값 받아오기
const getInfo = (r,type) => {
  switch(type){
    case 'cmp' : 
      state.leadParams.cmp_info_seq = r.cmp_info_seq
      state.leadParams.cmp_nm = r.cmp_nm
      state.leadParams.cmp_dvsn_nm = r.cmp_dvsn_nm
    break;
    case 'sale':
      state.leadParams.sales_id = r.sales_id
    break
  }
 
};

//이벤트 모달에서 값 받아오기
const getEventInfo = (r) => {
  state.leadParams.event_nm = r.event_nm
  state.leadParams.event_seq = r.ev_seq
};

//첨부파일 및 저장 상태값 확인
const checkValidation = async(status) => {
  //6가지 항목  성향 -> default 값 존재
  let msg = codeStore.getCodeMsg('77777'); // 해당 항목은 필수 입력값입니다.
    
  if(status !== 'T'){
  
    if (!state.leadParams.cmp_info_seq.trim()) {  //회사
      alert(msg);
      cmpNmRef.value.input.focus();
      return false;
    }
  
  
    if (!state.leadParams.usr_nm.trim()) {  //이름
      alert(msg);
      nameRef.value.input.focus();
      return false;
    }
  
    if (!state.leadParams.mobile.trim()) {  //휴대폰번호
      alert(msg);
      mobileRef.value.input.focus();
      return false;
    }

    if (state.leadParams.mobile.length < 13 ) {  //휴대폰번호 자릿수 체크 
    alert('휴대전화 번호를 확인하세요')
    mobileRef.value.input.focus();
    return false;
  }
  
    if (!state.leadParams.trend_cd) {  //성향
      alert(msg);
      trendRef.value.focus();
      return false;
    }

    if (!state.leadParams.oprtn_cd) {  
      alert(msg);
      omtSelectRef.value.focus();
      return false;
    }

    if(state.leadParams.oprtn_cd === 'OMT02' && !state.leadParams.sales_id){
      alert(msg);
      salesIdRef.value.input.focus();
      return false;
    }

    if(state.leadParams.oprtn_cd === 'OMT03' && !state.leadParams.omit_rst){
      alert(msg);
      omitRstRef.value.input.focus();
      return false;
    }

    if(state.leadParams.email && getEmailMark(state.leadParams.email.trim()) == false){
      emailRef.value.input.focus();
      return false;
    }

    //Caption 데이터 검증
    let res = await captionRef.value.checkValidation()
    if(!res){
      return
    }
    
  }

  if(confirm('등록하시겠습니까?')){
    //임시저장 및 저장 상태값
    state.leadParams.end_yn = status
    state.leadParams.tmp_yn = status === 'T' ? 'Y' : 'N'
    RegClick()
  }

}


const RegClick = async () => {

     //파일 첨부 데이터가 있는지 확인
    let tmpFiles = fileUploadRef.value.state.tmpFileList
    if (tmpFiles.length > 0) {
      //임시파일이 있으면 실제 경로 저장
      fileUploadRef.value.uploadFile('lead/file')
      return
    }
    
    if (state.fileList.length > 0) {
      state.leadParams.attachFileVO.file_seq = state.fileList.toString()
    }

    if (state.delFileList.length > 0) {
      state.leadParams.attachFileVO.del_file_seq = state.delFileList.toString()
    }

  // 등록, 수정 처리

  try {
    setIsLoading(true)
    const res = await leadEdit(state.leadParams)
    if(res.code === '0000' && res.rtn?.ld_seq){
      const capRes = await captionRef.value.saveCapCtnt(res.rtn.ld_seq)

      if(capRes.code === '0000'){
          if(state.leadParams.tmp_yn === 'Y'){
            routerCmn.routerPush('MSM_SA_006', { ld_seq: res.rtn.ld_seq})
            return
          }else{
            alert('등록 성공 조회 페이지로 이동합니다.')
            router.push({ name: 'MSM_SA_005' })
            return
          }
          
      }
    }

    alert('등록에 실패했습니다.')
  } catch (err) {
    console.error(err)
    alert("전송 중 에러가 발생하였습니다.");
  } finally {
    // setIsLoading(false)
  }
}


//업로드 파일 저장 후 실행되는 함수
const getFileList = (res) => {
  if (res && res?.length > 0) {
    res.map((file) => {
      state.fileList.push(file.file_seq)
    })
    RegClick()
  }
  else {
    alert('파일 업로드에 실패했습니다.')
  }

}


function openEventModal() {
  srchEventModal.value.openModal()
}

async function getCompCls(){
  try {
    setIsLoading(true)
    const res = await classList()
    state.cmpCls = [...res.rtn]
  } catch (err) {
    console.error(err)
  } finally {
    // setIsLoading(false)
  }
}

function updateProdSelect(data){
  if(data){
    state.inst_cd = {}
    state.inst_cd[data.class_id] = true
    state.leadParams.indst_cd = data.class_id
  }else{
    state.leadParams.indst_cd = ''
  }
}
</script>